import { useQuery } from '@tanstack/react-query';
import { InsuranceDetails } from '@web-app/graphql/healthie/queries/get-client-insurance-details/types';
import { QUERY_INSURANCE_DETAILS_KEY } from '@web-app/hooks/consts';

const getInsuranceDetails = async (
  healthieUserId?: string,
): Promise<InsuranceDetails> => {
  const res = await fetch(
    `/api/healthie/client/${healthieUserId}/insurance-details`,
  );

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    const errorMessage =
      errorData?.error || 'Failed to fetch insurance details';
    throw new Error(errorMessage);
  }

  return res.json();
};

export const useGetInsuranceDetails = (healthieUserId?: string) =>
  useQuery({
    queryKey: [QUERY_INSURANCE_DETAILS_KEY, healthieUserId],
    enabled: !!healthieUserId,
    queryFn: () => getInsuranceDetails(healthieUserId),
  });
